export default function Projects() {

    return (
        <section className="flex flex-col items-center">
            <h1 className='text-center my-6 md:mt-0 text-4xl font-bold'>My Projects</h1>
            <div className="carousel w-11/12 md:w-1/2 mb-2">
                <div id="item1" className="carousel-item flex-col w-full card bg-secondary">
                    <figure><img src="./dungeon-tracker.png" alt="Dungeon Tracker" className="w-full" /></figure>
                    <div className="card-body">
                        <h1 className="card-title">Dungeon Tracker</h1>
                        <p className="text-sm">Dungeon Tracker is a Dungeons & Dragons campaign management application that simplifies campaign organization. Dungeon Tracker reduces the friction of organizing information for a Dungeons & Dragons campaign, which has been a pain point for players since the inception of the game.</p>
                        <div className="justify-around card-actions">
                            <a href="https://github.com/Adamtpacz/dungeon-tracker-fe" className="badge badge-lg">Link to GitHub</a>
                            <a href="https://dungeon-tracker.netlify.app/" className="badge badge-lg">Link to Site</a>
                        </div>
                    </div>
                </div>
                <div id="item2" className="carousel-item flex-col w-full card bg-secondary">
                    <figure><img src="./sei-pets-alive.png" alt="SEI Pets Alive" className="w-full" /></figure>
                    <div className="card-body">
                        <h1 className="card-title">SEI Pets Alive</h1>
                        <p className="">SEI Pets Alive is a user-friendly dog adoption web application that allows users to view adoptable dogs and submit applications for adoption.</p>
                        <div className="justify-around card-actions">
                            <a href="https://github.com/Adamtpacz/sei-pets-alive" className="badge badge-lg">Link to GitHub</a>
                            <a href="https://sei-pets-alive.herokuapp.com/" className="badge badge-lg">Link to Site</a>
                        </div>
                    </div>
                </div>
                <div id="item3" className="carousel-item flex-col w-full card bg-secondary">
                    <figure><img src="./nosh-hunt.png" alt="Nosh Hunt" className="w-full" /></figure>
                    <div className="card-body">
                        <h1 className="card-title">Nosh Hunt</h1>
                        <p className="text-sm">Nosh Hunt is a restaurant tracking app that makes it easy to create and manage curated lists of restaurants that a user wants to visit. The application makes creating, updating and deleting curated lists of restaurants as smooth as butter!</p>
                        <div className="justify-around card-actions">
                            <a href="https://github.com/Adamtpacz/nosh-hunt" className="badge badge-lg">Link to GitHub</a>
                            <a href="https://nosh-hunt.herokuapp.com/" className="badge badge-lg">Link to Site</a>
                        </div>
                    </div>
                </div>
                <div id="item4" className="carousel-item flex-col w-full card bg-secondary">
                    <figure><img src="./memory-game.png" alt="Memory Matcher Game" className="w-full" /></figure>
                    <div className="card-body">
                        <h1 className="card-title">Memory Matcher Game</h1>
                        <p className="">The Fairy Tale Memory Game is a riff off the classic memory game - Concentration! Pair up the 8 fantasy themed cards before the time runs out!</p>
                        <div className="justify-around card-actions">
                            <a href="https://github.com/Adamtpacz/memory-game" className="badge badge-lg">Link to GitHub</a>
                            <a href="https://adamtpacz.github.io/memory-game/" className="badge badge-lg">Link to Site</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-center w-full py-2 gap-2">
                <a href="#item1" className="btn btn-md">1</a>
                <a href="#item2" className="btn btn-md">2</a>
                <a href="#item3" className="btn btn-md">3</a>
                <a href="#item4" className="btn btn-md">4</a>
            </div>
        </section>
    )
}